import { useMemo } from 'react';

import { FIELD_CONFIG } from '../../../../../configs/columns';
import { activeTradesComparisonColsOrder, ComparisonData } from '../comparisonTable.config';
import { getValueByPath } from '../comparisonTable.utils';

const comparisonChartsLabels = [
  'UPB',
  'Bid PX',
  '# Loans',
  'C Balance',
  'O Balance',
  'WALA',
  'WAM',
  'GWAC',
  'FICO',
  'LTV',
  'DTI',
];

export type ComparisonChartKey = (typeof comparisonChartsLabels)[number];

const useComparisonChartData = ({ comparisonData }: { comparisonData: ComparisonData[] }) => {
  const labels: string[] = [];
  const chartsValues: Record<ComparisonChartKey, number[]> = useMemo(() => {
    const cfg: Record<ComparisonChartKey, number[]> = {};
    const dataKeys = activeTradesComparisonColsOrder.slice(1, -1);

    dataKeys.forEach((order, idx) => {
      comparisonData.forEach((item) => {
        // cfg[comparisonChartsLabels[idx] as string]=getValueByPath(item, order)
        cfg[comparisonChartsLabels[idx]] = [
          ...(cfg?.[comparisonChartsLabels[idx]] ? cfg?.[comparisonChartsLabels[idx]] : []),
          getValueByPath(item, order),
        ];
        if ('name' in item.deal.counterparty) {
          labels.push(`${item.deal.listing.providedName} - BID ${item.bid_id}`);
        }
      });
    });

    return cfg;
  }, [comparisonData]);

  return {
    chartsValues,
    comparisonChartsLabels,
    labels,
  };
};

export default useComparisonChartData;
